import ConfigService from '../index'

class LupiService extends ConfigService {
    constructor(){
        super('lupi/api/v1/')
    }
}
export default LupiService
